import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/components/BookDemoSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/components/InlineStyle.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/node_modules/next/dist/client/link.js");
